// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dt1T","importantInfo":"styles_importantInfo__1d0Jb"};